import { ORDER_METHODS } from '../../services/exports/Constants';
import { includesOrderMethod, onSiteFieldOf } from '../../services/helpers/OrderMethodAliases';

/**
 * The State card of Order Methods → Table ordering (PROD-724). See
 * tests/components/takeout/tableOrderingState.test.js.
 */

export const TableOrderingNote = Object.freeze({
  /** Either switch off, with tables set up: their QR codes open the shop with Pickup and Delivery. */
  Off: 'off',
  /**
   * On but not visible: the shop doesn't offer it and the backend refuses every table order. Said
   * whether or not tables are set up, with a link to the visibility switch.
   */
  Hidden: 'hidden',
  /** Both switches on, but no table is on: guests can't order at a table yet. */
  NoActiveTable: 'no_active_table',
});

/** The two switches, from the form's data or the saved company, under either name. */
export function tableOrderingSwitches(source) {
  return {
    visible: !includesOrderMethod(source?.hidden_order_methods ?? [], ORDER_METHODS.on_site),
    on: Boolean(onSiteFieldOf(source, 'has_on_site', 'has_room_service')),
  };
}

/** Whether a switch differs from what's saved: Save is off until one does. */
export function isTableOrderingDirty(data, company) {
  const current = tableOrderingSwitches(data);
  const saved = tableOrderingSwitches(company);

  return current.visible !== saved.visible || current.on !== saved.on;
}

/**
 * The note in the State card. It describes what guests see now, so it follows the saved switches,
 * not unsaved changes. Nothing about tables while they load.
 */
export function tableOrderingNote(company, tables, loading = false) {
  const saved = tableOrderingSwitches(company);

  if (saved.on && !saved.visible) {
    return TableOrderingNote.Hidden;
  }

  if (loading) {
    return null;
  }

  if (!saved.visible || !saved.on) {
    return tables.length ? TableOrderingNote.Off : null;
  }

  return tables.some((table) => table.is_active) ? null : TableOrderingNote.NoActiveTable;
}
